import { render, staticRenderFns } from "./ManageAlert.vue?vue&type=template&id=5201cf7e&scoped=true"
import script from "./index.js?vue&type=script&lang=js&external"
export * from "./index.js?vue&type=script&lang=js&external"
import style0 from "./ManageAlert.vue?vue&type=style&index=0&id=5201cf7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5201cf7e",
  null
  
)

export default component.exports